import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { Form } from '@/components/ui/form'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../Customers/customers.slice'
import { Formik } from 'formik'
import { selectAccountUsers } from '../Account/account.selector'
import {
	selectSelectedRow,
	selectSelectedAccounts,
	selectSelectedAccountId,
	selectFilters,
} from '../Customers/customers.selectors'
import {
	fetchCustomers,
	updateCustomerAssignment,
} from '../Customers/customers.asynActions'
import { isEmpty } from 'lodash'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { USER_ROLES_ENUMS } from '../Account/account.constants'
import MultiSelect from '../../widgets/MultiSelect'

const { setSelectedCustomerModal, setSelectedAccounts } = actions

const EditAssignmentModal = () => {
	const dispatch = useDispatch()
	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
	}
	const accountUsers = useSelector(selectAccountUsers)
	const selectedRow = useSelector(selectSelectedRow)
	const selectedAccounts = useSelector(selectSelectedAccounts)
	const selectedAccount = useSelector(selectSelectedAccountId)
	const filters = useSelector(selectFilters)
	const [isSubmitting, setIsSubmitting] = useState(false)

	const salesRepresentatives = accountUsers.filter(
		(each) => each.userRole === USER_ROLES_ENUMS.SALES
	)

	const formattedUsers = salesRepresentatives
		.filter((each) => each.id !== selectedRow.assignmentId)
		.map((each) => {
			return {
				label: each.name,
				value: each.id,
			}
		})

	let ASSIGNED_ACCOUNTS = []
	ASSIGNED_ACCOUNTS =
		selectedAccount &&
		selectedAccount.assignments &&
		selectedAccount.assignments.map((each) => {
			return {
				...ASSIGNED_ACCOUNTS,
				value: each.id,
				label: each.name,
			}
		})

	const assignments =
		selectedAccounts && selectedAccounts.map((each) => each.assignments)

	const allAssignment = [].concat(...assignments)

	let FORMATTED_ALL_ASSIGNMENT = []
	FORMATTED_ALL_ASSIGNMENT =
		allAssignment &&
		allAssignment.map((each) => {
			return {
				...FORMATTED_ALL_ASSIGNMENT,
				value: each.id,
				label: each.name,
			}
		})

	const UNIQ_FORMATTED_ASSIGNMENT = FORMATTED_ALL_ASSIGNMENT.filter(
		(currentValue, index, arr) =>
			arr.findIndex((each) => each.value === currentValue.value) === index
	)

	useEffect(() => {
		dispatch(showModal())
	})

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const initialValues = {
		assignment: isEmpty(selectedAccounts)
			? ASSIGNED_ACCOUNTS
			: UNIQ_FORMATTED_ASSIGNMENT || '',
	}

	const getAccountId = () => {
		if (!isEmpty(selectedAccounts))
			return selectedAccounts.map((each) => each.id)
		else return [selectedAccount.id]
	}

	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				const authId = values.assignment.map((val) => val.value)
				setIsSubmitting(true)
				dispatch(
					updateCustomerAssignment({
						AccountId: getAccountId(),
						NewId: authId,
					})
				).then(({ payload }) => {
					payload &&
						dispatch(
							fetchCustomers({
								filters,
								useCaching: false,
							})
						)
					dispatch(setSelectedCustomerModal(null))
					dispatch(setSelectedAccounts([]))
					resetForm()
					setSubmitting(false)
					setIsSubmitting(true)
				})
			}}
		>
			{({ values, handleChange, handleBlur, handleSubmit }) => {
				const footer = (
					<>
						<Button
							className='h-50 w-190'
							variant='outline'
							onClick={handleClose}
						>
							Cancel
						</Button>
						<Button
							className='h-50 w-190'
							onClick={handleSubmit}
							disabled={isSubmitting}
						>
							<BusyIndicator region={REGIONS.UPDATE_CUSTOMER_ASSIGNMENT}>
								Update
							</BusyIndicator>
						</Button>
					</>
				)
				return (
					<Modal
						footer={footer}
						reset={resetModal}
						title='Edit Assignment'
						size='md'
					>
						<div className='f-14'>
							<div classname={'form-group'}>
								<h6 className='mb-25'>
									Assign this account to the appropriate sales representative
								</h6>
								<MultiSelect
									name='assignment'
									placeholder={values.assignment.length ? '' : 'Select'}
									value={values.assignment}
									options={formattedUsers}
									onChange={(selectedOption) => {
										const event = {
											target: {
												name: 'assignment',
												value: selectedOption,
											},
										}
										handleChange(event)
									}}
									onBlur={() => {
										handleBlur({ target: { name: 'assignment' } })
									}}
									isSearchable={false}
								/>
							</div>
						</div>
					</Modal>
				)
			}}
		</Formik>
	)
}
export default EditAssignmentModal
